package org.example.willfreightnew.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.willfreightnew.components.util.Constants.FONT_FAMILY
import org.example.willfreightnew.toSitePalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.example.willfreightnew.components.models.Contact
import org.example.willfreightnew.ContactCardStyle
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.dom.Br
import com.varabyte.kobweb.compose.foundation.layout.Spacer

@Composable
fun AddressCard(contact: Contact) {
    Column(
        modifier = ContactCardStyle.toModifier()
            .minWidth(350.px)
            .maxWidth(20.percent)
            .margin(all = 20.px)
            .padding(all = 20.px)
    ) {
        Row() {
            Box(
                modifier = Modifier
                    .id("iconBox")
                    .padding(all = 10.px)
                    .margin(bottom = 5.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = ColorMode.current.toSitePalette().contrastBackground
                    )
                    .backgroundColor(Colors.White)
                    .borderRadius(
                        topLeft = 20.px,
                        topRight = 20.px,
                        bottomLeft = 0.px,
                        bottomRight = 20.px
                    ),
                contentAlignment = Alignment.TopStart

            ) {

                Image(
                    modifier = Modifier
                        .id("icon")
                        .size(30.px)
                        .color(Colors.White),
                    src = Contact.Address.icon,
                    alt = Contact.Address.imageDesc,
                )

            }
            P(
                attrs = Modifier
                    .id("title")
                    .textAlign(TextAlign.Center)
                    .align(Alignment.Bottom)
                    .margin(top = 10.px, bottom = 10.px, left = 10.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs()
            ) {
                Text(Contact.Address.title)
            }
        }
        Box(
            modifier = Modifier
                .id("divider-line")
                .height(1.px)
                .margin(top = 5.px, bottom = 10.px)
                .borderRadius(r = 50.px)
                .fillMaxWidth()
        )

        P(
            attrs = Modifier
                .fillMaxWidth()
                .color(ColorMode.current.toSitePalette().brand.primary)
                .margin(top = 0.px, bottom = 0.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(16.px)
                .fontWeight(FontWeight.Light)
                .toAttrs()
        ) {
            SpanText("Will Freight Services", Modifier.fontWeight(FontWeight.Bold))
            Br()
            Text("Unit B4, Antrim Enterprise Agency")
            Br()
            Text("58 Greystone Road")
            Br()
            Text("Antrim")
            Br()
            Text("BT41 1JZ ")
        }
    }
}

@Composable
fun DetailsCard(contact: Contact) {
    Column(
        modifier = ContactCardStyle.toModifier()
            .minWidth(350.px)
            .maxWidth(20.percent)
            .margin(all = 20.px)
            .padding(all = 20.px)
    ) {
        Row() {
            Box(
                modifier = Modifier
                    .id("iconBox")
                    .padding(all = 10.px)
                    .margin(bottom = 5.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Solid,
                        color = ColorMode.current.toSitePalette().contrastBackground
                    )
                    .backgroundColor(Colors.White)
                    .borderRadius(
                        topLeft = 20.px,
                        topRight = 20.px,
                        bottomLeft = 0.px,
                        bottomRight = 20.px
                    ),
                contentAlignment = Alignment.TopStart

            ) {

                Image(
                    modifier = Modifier
                        .id("icon")
                        .size(30.px)
                        .color(Colors.White),
                    src = Contact.Details.icon,
                    alt = Contact.Details.imageDesc,
                )

            }
            P(
                attrs = Modifier
                    .id("title")
                    .textAlign(TextAlign.Center)
                    .align(Alignment.Bottom)
                    .margin(top = 10.px, bottom = 10.px, left = 10.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs()
            ) {
                Text(Contact.Details.title)
            }
        }
        Box(
            modifier = Modifier
                .id("divider-line")
                .height(1.px)
                .margin(top = 5.px, bottom = 10.px)
                .borderRadius(r = 50.px)
                .fillMaxWidth()
        )

        P(
            attrs = Modifier
                .fillMaxWidth()
                .color(ColorMode.current.toSitePalette().brand.primary)
                .margin(top = 0.px, bottom = 0.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(16.px)
                .fontWeight(FontWeight.Light)
                .toAttrs()
        ) {
            SpanText("Phone: ", Modifier.fontWeight(FontWeight.Bold))
            SpanText("028 9442 9990")
            Spacer()
            SpanText("Email: ", Modifier.fontWeight(FontWeight.Bold))
            SpanText("info@willfreight.co.uk ")
        }
    }
}